import React from "react";
import classNames from "classnames";
import Icon from "components/Icon";

const ButtonContained = ({
  id,
  dataCy,
  text,
  icon,
  secondaryIcon,
  type = "default",
  disabled = false,
  onClick,
  className = "",
  buttonType = "button"
}) => {
  const baseStyles =
    "flex items-center justify-center gap-2 rounded-full px-6 transition-all duration-200 font-outfit text-[16px] leading-[var(--leading-btn)] border";
  const typeStyles = {
    default: disabled
      ? "h-12 font-bold bg-[var(--color-gray-100)] text-[var(--color-gray-600)] border-[var(--color-gray-100)] cursor-not-allowed opacity-50 pointer-events-none py-[14px]"
      : "h-12 font-semibold bg-[var(--color-blue-600)] text-white border-transparent hover:bg-[var(--color-blue-800)] py-[14px]",

    defaultOutline: disabled
      ? "h-12 font-semibold border-[var(--color-gray-100)] text-[var(--color-gray-300)] cursor-not-allowed opacity-50 pointer-events-none py-[14px]"
      : "h-12 bg-[var(--color-white)] font-semibold border-[var(--color-gray-100)] text-[var(--color-gray-800)] hover:border-[var(--color-gray-300)] hover-border-thicker-icon py-[14px]",

    medium: disabled
      ? "h-10 font-bold bg-[var(--color-gray-100)] text-[var(--color-gray-600)] border-[var(--color-gray-100)] cursor-not-allowed opacity-50 pointer-events-none py-[10px]"
      : "h-10 font-semibold bg-[var(--color-blue-600)] text-white border-transparent hover:bg-[var(--color-blue-800)] py-[10px]",
  
    mediumOutline: disabled
      ? "h-10 font-semibold border-[var(--color-gray-100)] text-[var(--color-gray-300)] cursor-not-allowed opacity-50 pointer-events-none py-[10px]"
      : "h-10 font-semibold border-[var(--color-gray-100)] text-[var(--color-gray-800)] hover:border-[var(--color-gray-300)] hover-border-thicker-icon py-[10px]",

    mediumOutlineIconRight: disabled
      ? "h-10 font-semibold border-[var(--color-gray-100)] text-[var(--color-gray-300)] cursor-not-allowed opacity-50 pointer-events-none py-[10px]"
      : "h-10 font-semibold border-[var(--color-gray-100)] text-[var(--color-gray-800)] hover:border-[var(--color-gray-300)] hover-border-thicker-icon py-[10px]",
  };

  return (
    <button
      id={id}
      data-cy={dataCy}
      className={classNames(baseStyles, typeStyles[type], className)}
      onClick={onClick}
      disabled={disabled}
      type={buttonType}
    >
      {secondaryIcon && <Icon name={secondaryIcon} size={16} className="text-inherit" />}
      {text}
      {icon && <Icon name={icon} size={16} className="text-inherit" />}
    </button>
  );
};

export default ButtonContained;